import { CONTAINER_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import FlexColumn from '../../layout/flex/column.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';
import styles from './body.module.scss';

const METADATA = Metadata.define({
  description: 'Body section for the Card component',
  extends: [pick(CONTAINER_ARGS, [{ name: 'column', default: true }])],
  name: 'Card Body',
});

export default class SpdsContainerCardBody extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-container-card-body';
  styles = styles;

  get column() {
    return this.args.column ?? true;
  }

  get component() {
    return this.column ? FlexColumn : FlexRow;
  }

  <template>
    <this.component
      class={{this.classes}}
      data-test-spds-container-card-body
      id={{this.id}}
      {{this.validateArguments}}
      ...attributes
    >
      {{yield}}
    </this.component>
  </template>
}

export const CARD_BODY_METADATA = SpdsContainerCardBody.metadata;
